/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { ERROR } from "constant/message";
import { USER_DATA_STORAGE } from "constant";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const userInfos = () => {
  try {
    const userDataStorage = localStorage.getItem(USER_DATA_STORAGE);
    let userInfo = null;
    if (userDataStorage !== null) {
      userInfo = JSON.parse(userDataStorage);
    }
    return userInfo;
  } catch (error) {
    console.log("userInfos eror", error);
    return ERROR;
  }
};
export default userInfos;
/* export const isSuperAdmin = (): void => {
  return userInfos().roles.some((i) => i.roleName === SUPER_ADMIN_ROLE);
}; */

export const isAdmin = () => {
  // return userInfos().role === "ADMIN" || userInfos().role === "SUPERADMIN";
  // console.log("ddd", userInfos().role);
  return (
    // userInfos()?.roles[0]?.roleName === "ADMIN" || userInfos()?.roles[0]?.roleName === "SUPERADMIN"
    // userInfos()?.roles[0]?.roleName === "ADMIN"
    userInfos()?.role === "ADMIN"
  );
};
export const isSuperAdmin = () => {
  return userInfos()?.role === "SUPERADMIN";
};
